import { IUserData } from '@Reducers/user';
import { useAppSelector } from '@Redux/hooks';
import { useEffect } from 'react';

const useOnEnter = (func: () => void, deps: any[]) => {
  const userData: IUserData = useAppSelector((state) => state.user.userData);
  const commonIsLoading: boolean = useAppSelector((state) => state.common.isLoading);

  useEffect(() => {
    if (commonIsLoading || !userData.id) return;
    try {
      func();
    } catch (error) {
      console.error('Error running on enter', error);
    }
  }, [commonIsLoading, userData.id, ...deps]);
};

export default useOnEnter;
